/**
 * @flow
 * @format
 */

import _LazyImage from './LazyImage';

export default _LazyImage;



// WEBPACK FOOTER //
// ./src/components/LazyImage/index.js